import React, { useContext } from 'react';
import { GridItem } from 'src/components/common/grids';
import { BoldText } from '../../styles';
import PropertiesSummary from '../PropertyTables/PropertiesSummary';
import MigrateStatusSelect from '../PropertyTables/MigrateStatusSelect';
import { MigrateFromSummary } from '../..';

const MigrateSummary = () => {
    const {
        summary,
        migrateAllState,
        setMigrateAllState,
        handleMigrateAll,
        loadingMigration,
        loadingSummary,
        handleExtend15Days,
        handleExtend30Days,
        userSummary } = useContext(MigrateFromSummary);
        
    return (
        <>
            <BoldText>Resúmen</BoldText>
            {
                summary && (

                    <GridItem sm={4} md={6} lg={8}>
                        <MigrateStatusSelect
                            value={migrateAllState}
                            setValue={setMigrateAllState}
                            text={"Migrar todo"}
                            handler={handleMigrateAll}
                            loadingMigration={loadingMigration}
                        />
                    </GridItem>
                )
            }
            <PropertiesSummary
                summary={summary}
                loadingSummary={loadingSummary}
                handleExtend15Days={handleExtend15Days}
                handleExtend30Days={handleExtend30Days}
                email={userSummary.values.email}
            />
        </>
    )
}

export default MigrateSummary;